import React, { useState, useEffect } from 'react';
import './Loader.css';

const Loader = ({ onFinish, loggedIn }) => {
  const [startAnimation, setStartAnimation] = useState(false);
  const [colorChange, setColorChange] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    let animationTimer, colorChangeTimer, finishTimer;

    if (typeof loggedIn === 'boolean' && loggedIn) {
      animationTimer = setTimeout(() => setStartAnimation(true), 2000);
      colorChangeTimer = setTimeout(() => setColorChange(true), 2000);
      finishTimer = setTimeout(() => {
        setShowLoader(false);
        onFinish();
      }, 2500);
    } else if (typeof loggedIn === 'boolean' && !loggedIn) {
      // Show loader for 1.5 + .5 seconds (animation out) when NOT logged in
      animationTimer = setTimeout(() => setStartAnimation(true), 750);
      colorChangeTimer = setTimeout(() => setColorChange(true), 750);
      finishTimer = setTimeout(() => {
        setShowLoader(false);
        onFinish();
      }, 1500);
    }

    return () => {
      clearTimeout(animationTimer);
      clearTimeout(colorChangeTimer);
      clearTimeout(finishTimer);
    };
  }, [onFinish, loggedIn]);

  if (!showLoader) return null; // Hide loader after timers complete

  return (
    <div className={`loader ${startAnimation ? 'animate' : ''}`}>
      <div className="logo">
        <svg
          width="200"
          height="65"
          viewBox="0 0 148 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M56 32C56 40.8366 48.8366 48 40 48C31.1634 48 24 40.8366 24 32C24 23.1634 31.1634 16 40 16C48.8366 16 56 23.1634 56 32ZM32 32C32 36.4183 35.5817 40 40 40C44.4183 40 48 36.4183 48 32C48 27.5817 44.4183 24 40 24C35.5817 24 32 27.5817 32 32Z"
            fill="#121314"
          />
          <path
            d="M80 32C80 40.8366 72.8366 48 64 48C55.1634 48 48 40.8366 48 32C48 23.1634 55.1634 16 64 16C72.8366 16 80 23.1634 80 32ZM56 32C56 36.4183 59.5817 40 64 40C68.4183 40 72 36.4183 72 32C72 27.5817 68.4183 24 64 24C59.5817 24 56 27.5817 56 32Z"
            fill="#121314"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0C3.58172 0 0 3.58172 0 8V32C0 40.8366 7.16344 48 16 48C24.8366 48 32 40.8366 32 32C32 23.1634 24.8366 16 16 16C13.0857 16 10.3534 16.7792 8 18.1405V0ZM8 32C8 36.4183 11.5817 40 16 40C20.4183 40 24 36.4183 24 32C24 27.5817 20.4183 24 16 24C11.5817 24 8 27.5817 8 32Z"
            fill="#121314"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M90 0C85.5817 0 82 3.58172 82 8V40C82 44.4183 85.5817 48 90 48V39.746C90.7179 41.0437 91.6189 42.2463 92.6863 43.3137C95.6869 46.3143 99.7565 48 104 48V40C101.878 40 99.8434 39.1571 98.3431 37.6569C96.8429 36.1566 96 34.1217 96 32C96 29.8783 96.8429 27.8434 98.3431 26.3431C99.8434 24.8429 101.878 24 104 24V16C99.7565 16 95.6869 17.6857 92.6863 20.6863C91.6189 21.7537 90.7179 22.9563 90 24.254V0Z"
            fill="#121314"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M135.323 16.3489C139.051 17.1403 142.374 19.2364 144.694 22.2598L138.347 27.1296L138.362 27.1463L125.69 36.9178C126.321 37.7268 127.106 38.4133 128.008 38.933C129.66 39.8838 131.596 40.2139 133.469 39.864C135.342 39.514 137.029 38.507 138.226 37.0241C139.422 35.5412 140.05 33.6799 139.997 31.7752L147.994 31.5504C148.101 35.3598 146.845 39.0824 144.451 42.0482C142.058 45.0139 138.685 47.028 134.939 47.7279C131.192 48.4278 127.319 47.7676 124.017 45.8661C120.714 43.9645 118.198 40.9466 116.923 37.3555C115.647 33.7643 115.695 29.8358 117.059 26.2769C118.422 22.7181 121.01 19.7627 124.359 17.9426C127.707 16.1226 131.595 15.5574 135.323 16.3489ZM124.078 33.1166L135.129 24.6372C134.659 24.4374 134.167 24.2819 133.661 24.1744C131.797 23.7787 129.853 24.0613 128.179 24.9713C126.505 25.8814 125.211 27.3591 124.529 29.1385C124.041 30.413 123.89 31.7824 124.078 33.1166ZM137.402 26.0996L138.343 27.1255C138.058 26.7547 137.743 26.4118 137.402 26.0996Z"
            fill="#121314"
          />
          <path
            d="M106 24C106 19.5817 109.582 16 114 16V48C109.582 48 106 44.4183 106 40V24Z"
            fill="#121314"
          />
          <rect
            id="bouncy"
            x="107"
            y="6"
            width="8"
            height="8"
            rx="4"
            fill="#BB99F2"
            className={`bouncy ${colorChange ? 'color-change' : ''}`}
          />
        </svg>
      </div>
      <div className="radial-animation"></div>
    </div>
  );
};

export default Loader;
